"use strict";

/**
 * @type Controller
 * @name RejectDialogCtrl
 * @packageName rundown_dialog_ctrl.js
 *
 * @description
 *
 * The `RejectDialogCtrl` interaction delete mdDialog for rundown
 *
 */
class RejectDialogCtrl {


    constructor( $scope, $mdDialog) {
        //Attach dependicies to class root
        this.$mdDialog = $mdDialog;

        //Ugly work around CANCEL button!
        $scope.reject = () => {
            this.reject();
        };

        $scope.cancel = () => {
            this.cancel();
        };

    }


    /*
     * managed CANCEL event from confirm dailog
     */
    reject () {
        this.$mdDialog.hide();
    }

    cancel(){
        this.$mdDialog.cancel();
    }
}


/*
 * Inject dependicies
 */
RejectDialogCtrl.$inject = ['$scope', '$mdDialog'];


/*
 * Browsify connection: execute controller
 */
module.exports = RejectDialogCtrl;
